export default class UncollectedDebtActions {

  static NEW_DATA = 'NEW_DATA';
  static UPDATE_DATA='UPDATE_DATA';
  static SHOW_DATA='SHOW_DATA';
  static VIEW_DATA='VIEW_DATA';
  static DELETE_DATA='DELETE_DATA';
  static ON_SUBMIT='ON_SUBMIT';
  static ERROR_DATA='ERROR_DATA';
  static PROCESS_DATA='PROCESS_DATA';
  static RESET_DATA='RESET_DATA';
  static GET_HELPER_UNCOLLECTEDDEBT='GET_HELPER_UNCOLLECTEDDEBT';
  static SUCCESS_DATA='SUCCESS_DATA';
  static ERROR_SERVER='ERROR_SERVER';
  static RESET_LIST='RESET_LIST';
  static submit(){
    return {
      type: UncollectedDebtActions.ON_SUBMIT
    };
  }

  static create(data) {
    return {
      type: UncollectedDebtActions.NEW_DATA,
      payload: data
    };
  }

  static update(data) {
    return {
      type: UncollectedDebtActions.UPDATE_DATA,
      payload: data
    };
  }

  static view(data) {
    return {
      type: UncollectedDebtActions.VIEW_DATA,
      payload: data
    };
  }

  static delete(data) {
    return {
      type: UncollectedDebtActions.DELETE_DATA
    };
  }

  static list(data) {
    return {
      type: UncollectedDebtActions.SHOW_DATA,
      payload: data
    };
  }
  static resetList() {
    return {
      type: UncollectedDebtActions.RESET_LIST
    };
  }
  static error(error){
    return {
      type: UncollectedDebtActions.ERROR_DATA,
      payload: error
    };
  }
  static success(){
    return {
      type: UncollectedDebtActions.SUCCESS_DATA,
    };
  }
  static process(){
    return {
      type: UncollectedDebtActions.PROCESS_DATA,
    };
  }
  static reset(){
    return {
      type: UncollectedDebtActions.RESET_DATA,
    };
  }
  static helper(data){
    return {
      type: UncollectedDebtActions.GET_HELPER_UNCOLLECTEDDEBT,
      payload:data
    };
  }
  static errorInternal(error){
    return {
      type: UncollectedDebtActions.ERROR_SERVER,
      payload: error
    };
  }
}